import DefaultRequest from "../api/DefaultRequest";

/* Model */
class SamlConfigurationModel extends App.Models.BaseModel {
  modelUrl = 'SamlConfiguration';
}

App.Models.SamlConfiguration = SamlConfigurationModel;

/* Collection */
class SamlConfigurationCollection extends App.Collections.BaseCollection {
  url = 'SamlConfiguration';
  model = App.Models.SamlConfiguration;
}

App.Collections.SamlConfigurations = SamlConfigurationCollection;

/* Router */
class SamlConfigurationRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'SamlConfiguration';
    const model = App.Models.SamlConfiguration;
    const collectionClass = App.Collections.SamlConfigurations;

    super(entityName, model, collectionClass);
  }

  customGridActions = [];

  makeListScreen = (layout) => {
    
    const btnNew = {
      "customJavaScript": "window.location = '#/SamlConfiguration/new';",
      "customLabel": "default.button.new"
    }

    if (layout) {
      const entity = layout.userInterfaceAction.userInterface.key;
      const tabIdSelector = this.getTabIdSelector();
      this.updateTabTitle(layout);
      
      if (!this.permissionDenied) {
        Monet.Form.checkFormTemplate("SamlConfigurationGrid");
        this.generateDatamapper(entity, layout);

        const form = this.renderMonetForm(entity, layout, tabIdSelector);
        
        if (this.beforeInitializeGrid) {
          this.beforeInitializeGrid(form, layout);
        }

        const samlGrid = new Greenmile.SamlConfiguration.Grid(layout);
        samlGrid.show();

        if (typeof (this.beforeList) !== "undefined") {
          this.beforeList();
        }
      }
    } else {
      new Greenmile.Components.AlertModal("Greenmile.error.layout.notFound")
        .show();
    }
    return this;
  }

  updateGrid = (callback) => {
    let error;

    try {
      const dataProvider = App.Forms.SamlConfiguration.dataProvider;
      const grid = App.Forms.SamlConfiguration.table;
      const columns = Monet.Grid.getGridLayout(App.Forms[this.entityName].layout.index, this.entityName);
      const loading = new Monet.UI.LoadingData();

      loading.init();
      loading.show();

      const request = new DefaultRequest({
        url: "/saml/idp/",
        success: function (data) {
          const hasNotIdps = !data.length;
          const samlCollection = new App.Collections.SamlConfigurations();
          const result = data.map(({ id, idp }) => {
            return { id, ...idp }
          });

          samlCollection.add(result);

          callback("SamlConfiguration", columns, samlCollection, false);

          if (hasNotIdps) {
            dataProvider.setData([]);
            grid.invalidate();
            Monet.Grid.Utils.hideGridNoResult("SamlConfiguration");
            Monet.Grid.Utils.showGridNoResult("SamlConfiguration");
            loading.hide();
          }

          loading.hide();
        }
      })
      request.send();
    } catch (e) {
      error = new Monet.Exception.ReturnError(
        this,
        "Error on update Saml Configuration data",
        e
      );
      error.console();
    }
  };

  batchDelete = (idsToDelete) => {
    const router = App.Objects.SamlConfiguration;
    idsToDelete.forEach((id, index, idsArray) => {
      const request = new DefaultRequest({
        url: `saml/idp/${id}`,
        method: 'DELETE',
        success: function () {
          if(index === (idsArray.length - 1)) {
            router.updateGrid(Monet.Grid.addDataToGrid, true);
            loading.hide();
          }
        },
        error: function(error) {
          const { error: errorMessage } = JSON.parse(error.response);
          router.showErrorExceptionOnPopupForm(errorMessage);
        }
      })
      request.send();
    })
  }
}

App.Routers.SamlConfiguration = SamlConfigurationRouter;